/**
 * Content gate — client-side unlock for cached pages.
 *
 * The gate is always rendered server-side so cached pages have a single
 * deterministic version. This script checks the iam_subscriber cookie
 * on load and unlocks immediately if present.
 */

function unlockGate(showMessage) {
	const gate = document.querySelector('.iam-content-gate');
	const gated = document.querySelector('.iam-gated-content');

	if (!gate && !gated) return;

	if (gate && showMessage) {
		const msg = document.createElement('div');
		msg.className = 'newsletter-msg newsletter-msg--success text-center my-3';
		msg.setAttribute('role', 'status');
		msg.textContent = 'Welcome back! Here\u2019s the rest of your article.';
		gate.parentNode.insertBefore(msg, gate);
		setTimeout(() => {
			msg.style.transition = 'opacity 0.3s';
			msg.style.opacity = '0';
			setTimeout(() => msg.remove(), 300);
		}, 4000);
	}

	if (gate) {
		gate.style.display = 'none';
	}
	if (gated) {
		gated.style.display = '';
	}
}

// Check cookie on page load — instant unlock for returning subscribers
if (document.cookie.split(';').some((c) => c.trim().startsWith('iam_subscriber='))) {
	unlockGate(false);
}

// Also listen for the iam:subscribed event (inline form submission)
document.addEventListener('iam:subscribed', () => {
	unlockGate(true);
});
